// SignupLink — a quiet text link under the sign-up button: "Sign in" for an
// existing account, the privacy policy, the terms. The caption ink, UNDERLINED
// (a link is never colour alone, persona elena at 150% zoom), the title ink on
// hover and press. The house focus ring comes from the brand reset
// (`a:focus-visible`), and on a touch screen the hit area is the 44pt floor —
// the sign-in page's own text link carries the same one.
//
//   SignupLink_privacy: { href: …, text: … }   // the key's prefix names this component
//
// Rule 65: every state is declared here, on the primitive, never at a call site.
//
// THE TOUCH FLOOR is `touchFloor` of components/_touchTarget.js (read it for the
// why: an `:after` hit area at least `controlH` square, centred on the link, so
// the link's own box and the layout never change). It is written out here because
// frank-audit FA001 forbids a sibling import in a component file; the two are
// pinned equal by __tests__/signupPageAudit.test.js, so they cannot drift.
export const SignupLink = {
  extends: 'Link',
  color: 'caption',
  fontWeight: '400',
  textDecoration: 'underline',
  ':hover': { color: 'title' },
  ':active': { color: 'title' },
  '@coarse': {
    position: 'relative',
    ':after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '100%',
      height: '100%',
      minWidth: 'controlH',
      minHeight: 'controlH',
      transform: 'translate(-50%, -50%)'
    }
  }
}
